module.exports = __webpack_public_path__ + "img/indonesia.3c197f62.svg";